import { render, staticRenderFns } from "./BroadcastTypeList.vue?vue&type=template&id=10b6ab9c&scoped=true&"
import script from "./BroadcastTypeList.vue?vue&type=script&lang=js&"
export * from "./BroadcastTypeList.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastTypeList.vue?vue&type=style&index=0&id=10b6ab9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b6ab9c",
  null
  
)

export default component.exports